import { render, staticRenderFns } from "./StaffTask.vue?vue&type=template&id=19a52a04&"
import script from "./StaffTask.vue?vue&type=script&lang=ts&"
export * from "./StaffTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports